import { Button, Dialog, P } from '@fashionnovateam/nova-ui-toolkit';
import React from 'react';
import { VendorContact } from './VendorTeamMembersDataGrid';

type RemoveContactDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  contactToEdit?: VendorContact | null;
  removeContact: (contact?: VendorContact | null) => void;
};

export function RemoveContactDialog({
  isOpen,
  onClose,
  contactToEdit,
  removeContact,
}: RemoveContactDialogProps) {
  return (
    <Dialog isOpen={isOpen} onClose={onClose} className="md:w-[500px]">
      <Dialog.Header>
        <Dialog.Title />
      </Dialog.Header>
      <Dialog.Content>
        <P size="2xl" weight="medium">
          Are you sure you want to deactivate {contactToEdit?.first_name}{' '}
          {contactToEdit?.last_name}’s account?
        </P>
        <P size="xsm" color="disabled" className="mt-2">
          They will no longer have access to their account.
        </P>
      </Dialog.Content>
      <Dialog.Footer>
        <div className="flex gap-2">
          <Button color="secondary" onClick={onClose}>
            Go Back
          </Button>
          <Button
            color="error"
            onClick={() => {
              removeContact(contactToEdit);
              onClose();
            }}
          >
            Yes, Deactivate
          </Button>
        </div>
      </Dialog.Footer>
    </Dialog>
  );
}
